import React from 'react'

const Imprint = () => {
  return (
    <div className='componentFirst'>
      <div className='componentSecond'>
        <div className='privacy'>
          <div className='privacyTitle'>Impressum</div>
          <div className='privacySubTitle'>
            Dieses Impressum gilt für die Website www.finanzfachkrafti.ch und Social Media Accounts auf Facebook,
            Instagram, Twitter und LinkedIn
          </div>
          <div className='privacyTitle'>Seitenbetreiber und Verantwortlicher:</div>
          <div className='privacyText privacyTextBold'>Adresse</div>
          <div className='privacyText'>Bodenmatte 3, 6062 Wilen (Sarnen)</div>
          <div className='privacyText privacyTextBold'>Rechtsform</div>
          <div className='privacyText'>Einzelunternehmen</div>
          <div className='privacyText privacyTextBold'>Geschäftsführer</div>
          <div className='privacyText'>Andrea Solèr</div>
          <div className='privacyText privacyTextBold'>Telefonnummer</div>
          <div className='privacyText'>+41 41 932 18 38</div>
          <div className='privacyText privacyTextBold'>E-Mail-Adresse</div>
          <div className='privacyText'>andrea.soler@finanzfachkraft.ch</div>
        </div>
      </div>
    </div>
  )
}

export default Imprint
